import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, userData, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FCF8F9] flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-[#EFA9B6] border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  // If no user - only redirect on MOBILE
  if (!user) {
    const isMobile = window.innerWidth < 768;
    if (isMobile) {
      return <Navigate to="/login" />;
    }
    // Desktop: allow rendering (locked state handled in layout)
    return children;
  }

  // Role check
  if (requiredRole) {
    const userRole = userData?.userType || userData?.role || 'client';
    if (userRole !== requiredRole) {
      if (userRole === 'professional') {
        return <Navigate to="/professional-dashboard" />;
      } else {
        return <Navigate to="/dashboard" />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;